import React from 'react';
import { GitFork, BrainCircuit, FileCheck, UserPlus, ClipboardCheck, MapPin, DoorOpen, Database } from 'lucide-react';
import { RadialOrbitalTimeline } from './RadialOrbitalTimeline';
const timelineData = [{
  id: 1,
  title: 'Two Partnership Paths',
  date: '2025',
  content: 'Full buy-out or platform roll-up — doctors choose the structure that fits their goals. No one-size-fits-all.',
  category: 'Structure',
  icon: GitFork,
  relatedIds: [2, 7],
  status: 'completed' as const,
  energy: 100
}, {
  id: 2,
  title: 'AI-Run Back Office',
  date: '2025',
  content: 'We replace back-office headcount with AI-driven systems. Lower overhead, tighter margins, faster decisions — without adding managers.',
  category: 'Operations',
  icon: BrainCircuit,
  relatedIds: [1, 3],
  status: 'completed' as const,
  energy: 95
}, {
  id: 3,
  title: 'Centralized Credentialing & Billing',
  date: '2025',
  content: 'Credentialing, billing, and insurance handled from HQ. Your front desk stops chasing paperwork and starts focusing on patients.',
  category: 'Operations',
  icon: FileCheck,
  relatedIds: [2, 5],
  status: 'completed' as const,
  energy: 90
}, {
  id: 4,
  title: 'Built-In Patient Acquisition',
  date: '2025',
  content: 'Every partner clinic plugs into our marketing engine on day one. Referral response, digital campaigns, and local growth — all built in.',
  category: 'Growth',
  icon: UserPlus,
  relatedIds: [5, 6],
  status: 'completed' as const,
  energy: 85
}, {
  id: 5,
  title: 'Standardized Integration Playbook',
  date: '2025',
  content: 'Three phases: Red Tape → Systems → Growth. Every clinic runs the same plays, adapted to local context. No guesswork.',
  category: 'Operations',
  icon: ClipboardCheck,
  relatedIds: [3, 4],
  status: 'completed' as const,
  energy: 90
}, {
  id: 6,
  title: 'Texas & Florida Focus',
  date: '2025',
  content: 'We concentrate in two high-growth markets to maximize density, referral networks, and operational leverage.',
  category: 'Growth',
  icon: MapPin,
  relatedIds: [4, 7],
  status: 'in-progress' as const,
  energy: 80
}, {
  id: 7,
  title: 'Succession & Platform Exit',
  date: '2025',
  content: 'We build toward a multi-clinic platform recapitalization. Partners participate in the exit — the second bite is where the real value lives.',
  category: 'Strategy',
  icon: DoorOpen,
  relatedIds: [1, 8],
  status: 'in-progress' as const,
  energy: 75
}, {
  id: 8,
  title: 'Data & KPI Management',
  date: '2025',
  content: 'Standardized metrics across every clinic. Real-time visibility into what matters — collections, visit volume, conversion, and margin.',
  category: 'Operations',
  icon: Database,
  relatedIds: [2, 7],
  status: 'in-progress' as const,
  energy: 70
}];
export function DifferentiatorsTimeline() {
  return <RadialOrbitalTimeline timelineData={timelineData} data-id="element-60" />;
}